import { render, staticRenderFns } from "./tree-slot.vue?vue&type=template&id=3d37d513"
import script from "./tree-slot.vue?vue&type=script&lang=js"
export * from "./tree-slot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports